import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DialogModule } from '../dialog/dialog.module';
import { FeaturesModule } from '../features/features.module';
import { FeedModule } from '../feed/feed.module';
import { FormMasterModule } from '../form-master/form-master.module';
import { SearchModule } from '../search/search.module';
import { SharedModule } from '../shared/shared.module';
import { ToasterModule } from '../toaster/toaster.module';
import { FeedbackModule } from '../feedback/feedback.module';
import { DeleteEntityToastComponent } from './components/delete-entity-toast/delete-entity-toast.component';
import { EntityMasterComponent } from './components/entity-master/entity-master.component';
import { MasterListItemComponent } from './components/master-list-item/master-list-item.component';
import { MasterListComponent } from './components/master-list/master-list.component';
import { TaxYearFilterDialogComponent } from './components/tax-year-filter-dialog/tax-year-filter-dialog.component';
import { SearchListComponent } from './components/search-list/search-list.component';
import { I2gNgUiModule } from 'i2g-ng-ui';

const components = [
  MasterListComponent,
  MasterListItemComponent,
  DeleteEntityToastComponent,
  TaxYearFilterDialogComponent,
  EntityMasterComponent,
  SearchListComponent,
];

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ToasterModule,
    RouterModule,
    FeedModule,
    SearchModule,
    FormMasterModule,
    DialogModule,
    FeaturesModule,
    FeedbackModule,
    I2gNgUiModule,
  ],
  declarations: [...components],
  entryComponents: [DeleteEntityToastComponent],
  exports: [...components, ToasterModule],
})
export class EntityMasterModule {}
